module.exports = __webpack_public_path__ + "img/7.417aef52.png";